// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-select-container {
  flex: 1 1;
}
.input-select-container .input-select-title {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  margin-bottom: 8px;
  color: var(--sebrae-gray);
}
.input-select-container .input-select {
  width: 100%;
  position: relative;
  border-radius: 4px;
  border: 1px solid var(--sebrae-light-gray5);
}
.input-select-container .input-select__button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--sebrae-white);
  color: var(--sebrae-gray5);
  border: 1px solid var(--sebrae-light-gray8);
  border-radius: 4px;
  padding: 4px 8px 4px 12px;
  height: 32px;
  font-size: 13px;
  gap: 4px;
  line-height: 1.2;
  letter-spacing: -0.3px;
  text-align: left;
  cursor: pointer;
}
.input-select-container .input-select__button svg {
  width: 16px;
  height: 16px;
}
.input-select-container .input-select__button span {
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
}
.input-select-container .input-select__button.open {
  background-color: var(--sebrae-white);
  border-bottom: none;
  color: var(--sebrae-blue);
}
.input-select-container .input-select__placeholder {
  font-size: 13px;
}
.input-select-container .input-select__options {
  margin: -1px;
  top: 38px;
  left: 0;
  right: 0;
  position: absolute;
  border-radius: 0 0 4px 4px;
  background-color: var(--sebrae-white);
  border: 1px solid var(--sebrae-light-gray5);
  border-top: none;
  color: var(--sebrae-blue);
  z-index: 11;
  max-height: 240px;
  overflow-y: auto;
}
.input-select-container .input-select__options .wrapper-input {
  padding: 4px 12px;
}
.input-select-container .input-select__options .wrapper-input input,
.input-select-container .input-select__options .wrapper-input label {
  outline: none;
}
.input-select-container .input-select__options .wrapper-input label {
  height: 32px;
  background-color: var(--sebrae-white3);
  border-radius: 4px;
  padding: 0 8px;
}
.input-select-container .input-select__options .wrapper-input input::placeholder {
  color: var(--sebrae-light-gray7);
}
.input-select-container .input-select__options .wrapper-input svg {
  width: 16px;
  height: 16px;
  color: var(--sebrae-gray6);
}
.input-select-container .input-select__item {
  width: 100%;
  padding: 8px 12px;
  text-align: left;
  font-size: 13px;
  transition: background-color 0.2s ease, color 0.2s ease;
  line-height: 1.2;
  letter-spacing: -0.3px;
  cursor: pointer;
}
.input-select-container .input-select__item.selected {
  background-color: var(--sebrae-blue);
  color: var(--sebrae-white);
}
.input-select-container .input-select__item.selected span {
  color: var(--sebrae-white);
}
.input-select-container .input-select__item .subspan {
  font-size: 11px;
  color: var(--sebrae-blue);
}
@media screen and (min-width: 768px) {
  .input-select-container .input-select__button {
    height: 40px;
    padding: 8px 12px;
    font-size: 16px;
  }
  .input-select-container .input-select__placeholder, .input-select-container .input-select__item {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/select/index.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AACJ;AAEE;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,2CAAA;AAAJ;AAII;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qCAAA;EACA,0BAAA;EACA,2CAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AAFN;AAIM;EACE,WAAA;EACA,YAAA;AAFR;AAIM;EACE,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AAFR;AAIM;EAEE,qCAAA;EAEA,mBAAA;EACA,yBAAA;AAJR;AAOI;EACE,eAAA;AALN;AAOI;EAEE,YAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,0BAAA;EACA,qCAAA;EACA,2CAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AANN;AAQM;EACE,iBAAA;AANR;AAQQ;;EAEE,aAAA;AANV;AAQQ;EACE,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,cAAA;AANV;AASU;EACE,gCAAA;AAPZ;AAUQ;EACE,WAAA;EACA,YAAA;EACA,0BAAA;AARV;AAYI;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,uDAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AAVN;AAYM;EACE,oCAAA;EACA,0BAAA;AAVR;AAYQ;EACE,0BAAA;AAVV;AAcM;EACE,eAAA;EACA,yBAAA;AAZR;AAgBI;EACE;IACE,YAAA;IACA,iBAAA;IACA,eAAA;EAdN;EAgBI;IAEE,eAAA;EAfN;AACF","sourcesContent":[".input-select-container {\n  flex: 1;\n\n  .input-select-title {\n    font-size: 16px;\n    font-weight: 400;\n    font-style: normal;\n    margin-bottom: 8px;\n    color: var(--sebrae-gray);\n  }\n\n  .input-select {\n    width: 100%;\n    position: relative;\n    border-radius: 4px;\n    border: 1px solid var(--sebrae-light-gray5);\n\n    // max-width: 171px;\n\n    &__button {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      background-color: var(--sebrae-white);\n      color: var(--sebrae-gray5);\n      border: 1px solid var(--sebrae-light-gray8);\n      border-radius: 4px;\n      padding: 4px 8px 4px 12px;\n      height: 32px;\n      font-size: 13px;\n      gap: 4px;\n      line-height: 1.2;\n      letter-spacing: -0.3px;\n      text-align: left;\n      cursor: pointer;\n\n      svg {\n        width: 16px;\n        height: 16px;\n      }\n      span {\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        width: 100%;\n        overflow: hidden;\n      }\n      &.open {\n        // border-radius: 4px 4px 0 0;\n        background-color: var(--sebrae-white);\n        // border-color: var(--sebrae-blue);\n        border-bottom: none;\n        color: var(--sebrae-blue);\n      }\n    }\n    &__placeholder {\n      font-size: 13px;\n    }\n    &__options {\n      // width: 100%;\n      margin: -1px;\n      top: 38px;\n      left: 0;\n      right: 0;\n      position: absolute;\n      border-radius: 0 0 4px 4px;\n      background-color: var(--sebrae-white);\n      border: 1px solid var(--sebrae-light-gray5);\n      border-top: none;\n      color: var(--sebrae-blue);\n      z-index: 11;\n      max-height: 240px;\n      overflow-y: auto;\n\n      .wrapper-input {\n        padding: 4px 12px;\n\n        input,\n        label {\n          outline: none;\n        }\n        label {\n          height: 32px;\n          background-color: var(--sebrae-white3);\n          border-radius: 4px;\n          padding: 0 8px;\n        }\n        input {\n          &::placeholder {\n            color: var(--sebrae-light-gray7);\n          }\n        }\n        svg {\n          width: 16px;\n          height: 16px;\n          color: var(--sebrae-gray6);\n        }\n      }\n    }\n    &__item {\n      width: 100%;\n      padding: 8px 12px;\n      text-align: left;\n      font-size: 13px;\n      transition: background-color 0.2s ease, color 0.2s ease;\n      line-height: 1.2;\n      letter-spacing: -0.3px;\n      cursor: pointer;\n\n      &.selected {\n        background-color: var(--sebrae-blue);\n        color: var(--sebrae-white);\n        \n        span {\n          color: var(--sebrae-white);\n        }\n      }\n\n      .subspan {\n        font-size: 11px;\n        color: var(--sebrae-blue);\n      }\n    }\n\n    @media screen and (min-width: 768px) {\n      &__button {\n        height: 40px;\n        padding: 8px 12px;\n        font-size: 16px;\n      }\n      &__placeholder,\n      &__item {\n        font-size: 16px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
